import svg from "./starburst-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const StarburstIcon = makeSvgIcon(svg, "currentColor", {
  viewBox: "-10 -10 20 20",
});

export default StarburstIcon;
